import { FC, useState } from 'react';
import { Button } from '@mui/material';
import { DateTime } from 'luxon';
import { VAT_CORRECTION_CREATION_DATE } from 'services/constants/env';
import { EasTooltip } from 'ui/EasTooltip';
import { NewCorrectionDialog } from './NewCorrectionDialog';

export const CreateCorrectionButton: FC = () => {
	const [openCreateCorrection, setOpenCreateCorrection] = useState(false);

	const isCreationAvailable = DateTime.now().toFormat('yyyy-MM-dd') >= VAT_CORRECTION_CREATION_DATE;

	return (
		<>
			<EasTooltip
				title={`Due to the fiscal report generation process, creating of the VAT correction will be available after 3rd of ${DateTime.now().toFormat('MMMM')}`}
				disableHoverListener={isCreationAvailable}
				timeout={isCreationAvailable ? null : 3000}
				type="warning"
				arrow
				placement="top-start"
			>
				<span>
					<Button
						variant="contained"
						color="primary"
						size="small"
						style={{
							textTransform: 'none',
							padding: '2px 10px',
							borderRadius: '12px',
						}}
						onClick={() => setOpenCreateCorrection(true)}
						disabled={!isCreationAvailable}
					>
						Create New VAT Correction
					</Button>
				</span>
			</EasTooltip>
			<NewCorrectionDialog
				open={openCreateCorrection}
				setClose={() => setOpenCreateCorrection(false)}
			/>
		</>
	);
};
